import React from 'react'
import { useField } from 'formik'
import { FormField, Input, Label } from 'semantic-ui-react'

function MyTextInput({ label, ...props }) {
	const [field, meta] = useField(props)

	return (
		<FormField error={meta.touched && !!meta.error}>
			<label>{label}</label>
			<Input {...field} {...props} size='massive' />
			{meta.touched && meta.error ? (
				<Label basic color='red'>
					{meta.error}
				</Label>
			) : null}
		</FormField>
	)
}

export default MyTextInput
